<template>
  <div class="d-inline-block yt-live-wrapper">
    <div
      v-if="game.embedVideo?.source_type !== 'YOUTUBE'"
      class="yt-create-badge btn-dual"
      :class="{ 'yt-create-badge--disabled': !canCreate }"
      v-tooltip="$t('tooltip.createYoutubeEvent')"
      @click="canCreate && makeYTGameEvent()"
    >
      <span class="mr-1" style="position: relative; display: inline-flex; font-size: 18px; line-height: 1;">
        <i class="fa fa-youtube-play" style="color: #dc3545;"></i>
        <i class="fa fa-play" style="position: absolute; top: 50%; left: 53%; transform: translate(-50%, -50%); font-size: 0.42em; color: #fff;"></i>
      </span>
      <span>{{ $t('createEvent') }}</span>
      <span class="yt-create-badge__icon ml-2" style="font-size: 14px;">
        <i v-if="loading" class="fa fa-cog fa-spin"></i>
        <i v-else class="fa fa-plus yt-create-badge__icon--green"></i>
      </span>
    </div>
    <div v-else class="yt-active-badge bg-success" v-tooltip="$t('tooltip.removeYoutubeEvent')">
      <span class="yt-active-badge__label">
        <span class="mr-1" style="position: relative; display: inline-flex; font-size: 18px; line-height: 1;">
          <i class="fa fa-youtube-play" style="color: #dc3545;"></i>
          <i class="fa fa-play" style="position: absolute; top: 50%; left: 53%; transform: translate(-50%, -50%); font-size: 0.42em; color: #fff;"></i>
        </span>
        <span>{{ $t('eventCreated') }}</span>
      </span>
      <button :disabled="disableButtons || loading" class="yt-active-badge__delete btn-danger" @click="deleteYTGameEvent()">
        <i v-if="loading" class="fa fa-cog fa-spin"></i>
        <i v-else class="fa fa-trash-o"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { useExternalLinks } from '@/use/useExternalLinks'
import GameService from '@/services/game.service'

export default {
  props: {
    schedule: Object,
    game: Object,
    disableButtons: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false
    }
  },
  setup () {
    const { getGameWebsiteUrl } = useExternalLinks()

    return {
      getGameWebsiteUrl
    }
  },
  computed: {
    canCreate () {
      return !this.loading && !this.disableButtons && ['SCHEDULED', 'LIVE'].includes(this.game.status)
    }
  },
  watch: {
    size: 'changeSize'
  },
  methods: {
    deleteYTGameEvent () {
      this.loading = true
      GameService.deleteYtEvent(this.schedule.uuid, this.game.uuid).then(() => {
        this.emitChange()
      }).catch((error) => {
        if (error.response.data.message === 'connected-account-missing' && error.response.status === 422) {
          this.$router.push({ name: 'connected-account.index' })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    makeYTGameEvent () {
      this.loading = true
      GameService.createYtEvent(this.schedule.uuid, this.game.uuid).then(() => {
        this.emitChange()
      }).catch((error) => {
        if (error.response.data.message === 'connected-account-missing' && error.response.status === 422) {
          this.$router.push({ name: 'connected-account.index' })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    emitChange () {
      this.$emit('changed')
    }
  }
}
</script>
<style>
 .qr-button {
   display: block;
   border: 0;
   background: none;
   cursor: pointer;
 }
</style>
<style scoped lang="scss">
.yt-live-wrapper {
  vertical-align: middle;
}

.yt-create-badge {
  display: inline-flex;
  align-items: center;
  height: 32px;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0 0.5rem;
  font-size: 0.8rem;
  line-height: 1.5;
  cursor: pointer;

  &--disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    font-size: 0.7em;

    &--green {
      color: #28a745;
    }
  }
}

.yt-active-badge {
  display: inline-flex;
  align-items: stretch;
  height: 32px;
  box-sizing: border-box;
  background-color: #dc3545;
  color: #fff;
  border-radius: 4px;
  padding: 0;
  font-size: 0.8rem;
  line-height: 1.5;
  overflow: hidden;

  &__label {
    display: inline-flex;
    align-items: center;
    padding: 0 0.5rem;
  }

  &__delete {
    display: inline-flex;
    align-items: center;
    padding: 0 0.5rem;
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.8);
    margin-left: 0;
    cursor: pointer;
    line-height: 1;

    &:hover:not(:disabled) {
      color: #fff;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
</style>
